export default "__VITE_ASSET__BPEF1daI__"